import './bootstrap';

import { Apii } from './services/api.js';
window.ApiService = new Apii();
import router from './router';
import Filters from './filters';

import { createApp } from 'vue/dist/vue.esm-bundler';
import App from './App.vue';
import { createPinia } from 'pinia';
import Notifications from 'notiwind';
import tooltip from '@/directives/tooltip.js';
import VueCookies from 'vue-cookies';
import VueNumberFormat from 'vue-number-format';
import debounce from '@/directives/debounce';
import vClickOutside from 'click-outside-vue3';
import InputFormat from '@/directives/input-format';
import DecimalFormat from '@/directives/decimal-format';
import * as Sentry from '@sentry/vue';
import notify from './plugins/notify';

const app = createApp(App).use(Notifications);

const pinia = createPinia();

const dsn = import.meta.env.SENTRY_DSN;

Sentry.init({
    app,
    dsn: dsn,
    ignoreErrors: [
        'acsbJS',
        'Load failed',
        'runtime.sendMessage',
        'sendNativeMessage',
        'Java',
        'operation is insecure',
        'chrome-extension',
        'antifingerprint',
    ],
    integrations: [
        Sentry.vueIntegration({
            tracingOptions: {
                trackComponents: true,
                timeout: 500,
            },
        }),
        Sentry.thirdPartyErrorFilterIntegration({
            filterKeys: ['my10xisthebest'],
            // - 'drop-error-if-contains-third-party-frames'
            // - 'drop-error-if-exclusively-contains-third-party-frames'
            // - 'apply-tag-if-contains-third-party-frames'
            // - 'apply-tag-if-exclusively-contains-third-party-frames'
            behaviour: 'drop-error-if-contains-third-party-frames',
        }),
        Sentry.replayIntegration(),
    ],
    tracePropagationTargets: ['my.10xtravel.com'],
    allowUrls: [/https:\/\/my\.10xtravel\.com/],
    denyUrls: [/https?:\/\/my10x\.test/],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSendTransaction(event) {
        return event;
    },
});

app.use(router);
app.use(pinia);
app.use(VueCookies);
app.use(notify);

pinia.use(({ store }) => {
    store.$cookies = app.config.globalProperties.$cookies;
    store.$notify = app.config.globalProperties.$notify;
});

app.use(VueNumberFormat, {
    prefix: '',
    precision: 0,
    decimal: '.',
    thousand: ',',
});

app.directive('tooltip', tooltip);
app.directive('debounce', (el, binding) => debounce(el, binding));
app.directive('ClickOutside', vClickOutside.directive);
app.directive('InputFormat', InputFormat);
app.directive('DecimalFormat', DecimalFormat);

app.config.globalProperties.$filters = Filters;

app.mount('#app');
